<template>
  <div class="conteudo-container">
    <g-menu-sidebar
    class="conteudo-resumo-topo"
    titulofechado="Pedido - Gerar Novo Pedido"
    tituloaberto="Resumo"
    >
      <template #conteudo>
        <div class="conteudo-card-resumo-topo">
          <div class="grupo-parametros">
          <div class="titulo-icone-parametros">
            <i class="pi pi-check"></i>
            <div class="titulo-topico"> Parâmetros </div>
          </div>
          <div class="topico topico-parametros">
            <div class="parametros-pedido">
              <div class="titulo-resumo"> Pedido </div>
              <div class="conteudo"> {{resumoobj.codigoPedido}} </div>
            </div>
            <div class="parametros-tipo-pedido">
              <div class="titulo-resumo"> Tipo de Pedido </div>
              <div class="conteudo"> {{resumoobj.tipoPedidoTexto}} </div>
            </div>
            <div class="parametros-orcamento">
              <div class="titulo-resumo"> Orçamento </div>
              <div class="conteudo"> {{resumoobj.codigoExternoOrcamentoProduto}} </div>
            </div>
            <div class="parametros-representante">
              <div class="titulo-resumo"> Representante </div>
              <div class="conteudo"> {{resumoobj.nomeRepresentante}} </div>
            </div>
            <div class="parametros-unidade">
              <div class="titulo-resumo"> Unidade </div>
              <div class="conteudo"> {{resumoobj.nomeEmpresa}} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 1" class="grupo-cliente">
          <div class="titulo-icone">
            <i class="pi pi-user"></i>
            <div class="titulo-topico"> Cliente </div>
          </div>

          <div class="topico-cliente">
            <div class="cliente-razao-social">
              <div class="titulo-resumo"> Razão Social </div>
              <div class="conteudo conteudo-cliente-razao-social"> {{resumoobj.razaoSocial}} </div>
            </div>

            <div class="cliente-cnpj">
              <div class="titulo-resumo"> CNPJ </div>
              <div class="conteudo"> {{MascaraCnpj}} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 2" class="grupo-entrega">
          <div class="titulo-icone">
            <i class="pi pi-sync"></i>
            <div class="titulo-topico"> Entrega </div>
          </div>

          <div class="topico-entrega">
            <div class="entrega-frete">
              <div class="titulo-resumo"> Frete </div>
              <div class="conteudo"> {{resumoobj.indicadorDeTipoFreteTexto}} </div>
            </div>
            
            <div class="entrega-codigo-cidade">
              <div class="titulo-resumo"> Código Cidade </div>
              <div class="conteudo"> {{resumoobj.codigoCidade}} </div>
            </div>
            
            <div class="entrega-tipo-frete">
              <div class="titulo-resumo"> Tipo do Frete </div>
              <div class="conteudo"> Fracionado </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 3" class="grupo-produto">
          <div class="titulo-icone">
            <i class="pi pi-box"></i>
            <div class="titulo-topico"> Produto </div>
          </div>

          <div class="topico topico-produto">
            <div class="produto-nome">
              <div class="titulo-resumo"> Nome </div>
              <div class="conteudo conteudo-produto-nome"> {{resumoobj.nomeProduto}} </div>
            </div>
            
            <div class="quantidade-dia-carregamento">            
              <div class="produto-quantidade">
                <div class="titulo-resumo"> Quantidade </div>
                <div class="conteudo" v-for="data in resumoCarregamento"
                :key="data">{{data}}</div>
              </div>

              <div class="produto-data-carregamento">
                <div class="titulo-resumo"> Data de Carregamento </div>
                <div class="conteudo" v-for="data in resumoCarregamento"
                :key="data">{{data.dataQuantidadeCarregamento}}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </template>
    </g-menu-sidebar>

    <g-card :temCabecalho="false">
      <g-steps :metadeLargura="false" @RouterIndex="verificarTabs" :items="items"></g-steps>
    </g-card>

    <g-card-resumo
    class="conteudo-resumo-lateral"
    titulofechado="RESUMO DO PEDIDO" 
    tituloaberto="RESUMO DO PEDIDO"
    :larguraCResumoLateral="true"
    >
      <div class="conteudo-card-resumo">
        <div class="grupo-parametros">
          <div class="titulo-icone-parametros">
            <i class="pi pi-check"></i>
            <div class="titulo-topico"> Parâmetros </div>
          </div>
          <div class="topico topico-parametros">
            <div class="parametros-pedido">
              <div class="titulo-resumo"> Pedido </div>
              <div class="conteudo"> {{resumoobj.codigoPedido}} </div>
            </div>
            <div class="parametros-tipo-pedido">
              <div class="titulo-resumo"> Tipo de Pedido </div>
              <div class="conteudo"> {{resumoobj.tipoPedidoTexto}} </div>
            </div>
            <div class="parametros-orcamento">
              <div class="titulo-resumo"> Orçamento </div>
              <div class="conteudo"> {{resumoobj.codigoExternoOrcamentoProduto}} </div>
            </div>
            <div class="parametros-representante">
              <div class="titulo-resumo"> Representante </div>
              <div class="conteudo"> {{resumoobj.nomeRepresentante}} </div>
            </div>
            <div class="parametros-unidade">
              <div class="titulo-resumo"> Unidade </div>
              <div class="conteudo"> {{resumoobj.nomeEmpresa}} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 1" class="grupo-cliente">
          <div class="titulo-icone">
            <i class="pi pi-user"></i>
            <div class="titulo-topico"> Cliente </div>
          </div>

          <div class="topico-cliente">
            <div class="cliente-razao-social">
              <div class="titulo-resumo"> Razão Social </div>
              <div class="conteudo conteudo-cliente-razao-social"> {{resumoobj.razaoSocial}} </div>
            </div>

            <div class="cliente-cnpj">
              <div class="titulo-resumo"> CNPJ </div>
              <div class="conteudo"> {{MascaraCnpj}} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 2" class="grupo-entrega">
          <div class="titulo-icone">
            <i class="pi pi-sync"></i>
            <div class="titulo-topico"> Entrega </div>
          </div>

          <div class="topico-entrega">
            <div class="entrega-frete">
              <div class="titulo-resumo"> Frete </div>
              <div class="conteudo"> {{resumoobj.indicadorDeTipoFreteoEnum}} </div>
            </div>
            
            <div class="entrega-codigo-cidade">
              <div class="titulo-resumo"> Código Cidade </div>
              <div class="conteudo"> {{resumoobj.codigoCidade}} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 3" class="grupo-produto">
          <div class="titulo-icone">
            <i class="pi pi-box"></i>
            <div class="titulo-topico"> Produto </div>
          </div>

          <div class="topico topico-produto">
            <div class="produto-nome">
              <div class="titulo-resumo"> Nome </div>
              <div class="conteudo conteudo-produto-nome"> {{resumoobj.nomeProduto}} </div>
            </div>
            
            <div class="quantidade-dia-carregamento">            
              <div class="produto-quantidade">
                <div class="titulo-resumo"> Quantidade </div>
                <div class="conteudo" v-for="data in resumoCarregamento"
                :key="data.id"> {{ data.quantidadePedidoParcela }}</div>
              </div>

              <div class="produto-data-carregamento">
                <div class="titulo-resumo"> Data de Carregamento </div>
                <div class="conteudo" v-for="data in resumoCarregamento"
                :key="data">{{data.dataPedidoParcelaFormatada}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </g-card-resumo>
  </div>
</template>

<script>
import GerarNovoPedido from './GerarNovoPedido.js'
export default GerarNovoPedido
</script>

<style scoped>
  .quantidade-dia-carregamento{
    grid-template-columns: 35% 60%;
  }
  .titulo-icone {
    border-top: 1px solid #e9e9e9;
    margin-top: 20px;
    padding-top: 20px;
  }
  .titulo-resumo {
    color: #3e3e3e;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 500;
  }
  .conteudo {
    color: #8a8a8a;
    text-align: left;
    font-family: "MontSerrat";
    /* As linhas abaixo servem para colocar reticencias nas legendas se passarem do tamanho delimitado*/
    /* text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden; */
  }
  .conteudo-card-resumo-topo {
    padding: 0 10px;
  }
  .titulo-icone, .titulo-icone-parametros {
    color: #4f2c19;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  .titulo-icone-parametros {
    margin-top: 15px;
  }
  .titulo-topico {
    padding-left: 8px;
  }
  .topico-parametros {
    margin: 10px 0 20px 0;
  }
  .topico-entrega {
    display: flex;
    flex-wrap: wrap;
    column-gap: 30px;
    row-gap: 10px;
    margin: 10px 0 20px 0;
  }

  .topico, .quantidade-dia-carregamento, .topico-cliente {
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 10px;
  }
  .topico, .quantidade-dia-carregamento {
    grid-template-columns: 35% 60%;
  }
  .parametros-unidade{
    grid-area: 3 / 1 / 4 / 3;
  }

  .topico-produto {
    display: flex;
    flex-direction: column;
    margin: 10px 0 20px 0;
  }
  .topico-cliente {
    grid-template-columns: 55% 40.5%;
    margin: 10px 0 20px 0;
  }
  .ParametroLinha{
  grid-area: ParametroLinha;
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.Unidade{
  grid-area: Unidade;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.unidadeConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Representante{
  grid-area: Representante;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.representanteConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Tipo{
  grid-area: Tipo;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.tipoConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Orcamento{
  grid-area: Orcamento;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.orcamentoConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.RazaoSocial{
  grid-area: 2/1/3/2;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.razaoSocialConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Cnpj{
  grid-area: 2/2/3/3;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.cnpjConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Frete{
  grid-area: 2/1/3/2;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.freteConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.CodigoCidade{
  grid-area: 2/2/3/3;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.codigoCidadeConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.TipoDoFrete{
  grid-area: 2/3/3/4;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.tipoDoFreteConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.NomeProduto{
  grid-area: 2/1/3/2;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.nomeProdutoConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Quantidade{
  grid-area: 2/2/3/3;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.quantidadeConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.DiaDeCarregamento{
  grid-area: 2/3/3/4;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.diaDeCarregamentoConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Componente{
  grid-area: 3/1/4/2;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.componenteConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Medidas{
  grid-area: 3/2/4/3;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  text-align: left;
}

.medidasConteudo{
  font-family: "MontSerrat";
  font-size: 13px;
  font-weight: bold;
  align-self: center;
  color: #8a8a8a;
}

.Parametros{
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "ParametroLinha ."
                       "Orcamento Tipo "                  
                       "Representante Unidade";
                       justify-items:start;                     
  height: 12vh;
}

.Cliente{
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "ParametroLinha ."
                       "Orcamento Tipo "                  
                       "Representante Unidade";
                       justify-items:start;                     
  height: 10vh;
}

.Entrega{
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: "ParametroLinha ."
                       "Orcamento Tipo "                  
                       "Representante Unidade";
                       justify-items:start;                     
  height: 10vh;
}
.Produto{
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: "ParametroLinha ."
                       "Orcamento Tipo "                  
                       "Representante Unidade";
                       justify-items:start;                     
  height: 10vh;
}

.margem {
  margin: 20px;
}

.g-orc-menu {
  margin: 15px auto;
}

.titulo {
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  padding: 10px;
}

.subtitulo {
  margin-top: 5px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 25px;
  font-weight: bold;
}
.outrosubtitulo {
  margin-top: 10px;
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
}

.g-input-label {
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: left;
  justify-content: initial;
}

.p-dropdown {
  width: 90%;
}
.continuar {
  margin-top: 100px;
}

.p-inputtext {
    width: 90%;
}

.button_{
    margin-top: 30px
}

.button_2{
    margin-top: 10px
}

.bbbb{
  color: red;
}

.p-steps ul{
  margin-bottom: 30px;
  margin-top: 30px;
}



.titulo-container {
  display: flex;
  justify-content: space-between;
}
:deep(.p-sidebar .p-sidebar-header){
  padding: 0.5rem;
}

.card1{
  display: flex;
}


@media (min-width:310px) {
  .conteudo-resumo-topo {
    display: block;
  }
  .conteudo-resumo-lateral {
    display: none;
  }
}

@media (min-width:368px) {

}

@media (min-width:600px) {

}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
  .conteudo-resumo-topo {
    display: none;
  }
  .conteudo-resumo-lateral {
    display: block;
  }
  .conteudo-container{
    display: flex;
    justify-content: space-between;
  }

  .produtoNovo-container{
    display: none;
  }

  .resumoorcamento{
    display: inline;
    margin-bottom: 15px;
  }
}

@media (min-width:1281px) { 
    
}
</style>